import axios from '../../localAxios';
import { workspaceFoldersURL } from './../workspacesURLs';

type CreateWorkspaceFolderResponse = {
  id: string;
  name: string;
  createdDate: string;
  parentId: string;
  workspaceId: string;
};

export interface CreateWorkspaceFolderParams {
  workspaceId: string;
  folderName: string;
  parentId: string;
}

export async function createWorkspaceFolder({
  workspaceId,
  folderName,
  parentId,
}: CreateWorkspaceFolderParams) {
  const result = await axios.post<CreateWorkspaceFolderResponse>(
    workspaceFoldersURL({ workspaceId: workspaceId }).href,
    {
      name: folderName,
      parent_id: parentId,
    }
  );
  return result.data;
}
